import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { isStoresOnly } from "@nexseed/shared";
import { useAuth } from "@/features/auth/store";
import { VendorFormPage } from "@/features/masters/components/vendor-form-page";

/** A hand-made vendor (a trader Core does not send), on its own page. */
export const Route = createFileRoute("/_app/masters/vendors/new")({
  // `?stores=1`: opened from Stores, so the vendor starts as a Stores vendor.
  validateSearch: z.object({ stores: z.coerce.number().optional() }),
  beforeLoad: () => {
    if (!useAuth.getState().can("masters.vendors.add"))
      throw redirect({ to: "/masters/$key", params: { key: "vendors" } });
  },
  component: NewVendor,
});

function NewVendor() {
  const { stores } = Route.useSearch();
  // The store's login adds Stores vendors only (the API holds it there too).
  const storesOnly = useAuth((st) => isStoresOnly(st.can));
  return <VendorFormPage storesVendor={stores === 1 || storesOnly} />;
}
